import { BasePayloadMapper } from '@ps/utils';
import {
  BillingRulePayloadItemDto,
  BillingRulesPayloadDto,
} from '../dtos/buyer.dto';
import {
  BillingRuleItem,
  BillingRules,
  RuleEntry,
} from '../../state/buyer-state.model';

const ENTRY_LABELS: Record<RuleEntry, string> = {
  input: 'User Entry',
  fixed: 'Fixed',
};

export class BillingRulesPayloadMapper extends BasePayloadMapper<
  BillingRules,
  BillingRulesPayloadDto
> {
  public override toPayload(model: BillingRules): BillingRulesPayloadDto {
    return {
      mandatory: model.mandatory,
      autoGenerate: model.autoGenerate,
      length: { min: model.length.min, max: model.length.max },
      rules: model.rules.map((rule) => this._mapRuleItem(rule)),
    };
  }

  private _mapRuleItem(rule: BillingRuleItem): BillingRulePayloadItemDto {
    return {
      range: { start: rule.range.start, end: rule.range.end },
      entry: rule.entry,
      type:
        rule.entry !== null
          ? { label: ENTRY_LABELS[rule.entry], value: rule.entry }
          : null,
      required: rule.required,
      definition: rule.definition,
      char: rule.char,
    };
  }
}
